import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Color from '@styles/Color';

const ToggleWrap = styled(motion.div) <{
  isChecked?: boolean;
  disabled?: boolean;
}>`
  width: 40px;
  height: 22px;
  display: flex;
  border-radius: 50px;
  padding: 2px;
  justify-content: ${({ isChecked }) =>
    isChecked ? 'flex-end' : 'flex-start'};
  transition: background 0.2s;
  background: ${({ isChecked }) =>
    isChecked ? 'var(--primaryColor)' : Color.GRAY_4};
  opacity: ${({ disabled }) => (disabled ? 0.6 : '')};

  &:hover {
    cursor: ${({ disabled }) =>
    disabled ? 'not-allowed' : 'var(--hoverCursorURL), pointer'};
  }
`;

const ToggleBtn = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const ToggleCircle = styled(motion.div)`
  width: 18px;
  height: 18px;
  background-color: ${Color.WHITE};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
`;

const switchMap = {
  On: {
    enabled: Color.BLUE_8,
    disabled: Color.BLUE_6,
  },
  Off: {
    enabled: Color.GRAY_4,
    disabled: Color.GRAY_3,
  },
};

type switchType = {
  isChecked: boolean;
  handleSwitch: any;
  disabled?: boolean;
  id?: string;
  children?: any;
};

function Switch({
  isChecked,
  handleSwitch,
  disabled = false,
  id,
  children,
}: switchType) {
  const constraintsRef = useRef(null);

  const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 35,
  };

  function toggleSwitch(e) {
    e.stopPropagation();
    !disabled && handleSwitch(e);
  }

  return (
    <ToggleBtn>
      <ToggleWrap
        ref={constraintsRef}
        onClick={toggleSwitch}
        isChecked={isChecked}
        disabled={disabled}
        id={id}
      >
        <ToggleCircle
          layout
          transition={spring}
          whileTap={{ width: 24, borderRadius: '50px' }}
          drag="x"
          dragConstraints={{ top: 0, left: 0, right: 0, bottom: 0 }}
          dragMomentum={false}
          dragElastic={0}
          onDragEnd={toggleSwitch}
          dragTransition={{ bounceStiffness: 0, bounceDamping: 0 }}
        />
      </ToggleWrap>
      {children}
    </ToggleBtn>
  );
}

export default Switch;
